module.exports = __webpack_public_path__ + "static/media/img-8.737a0db3.jpg";